export interface Preis {
  vat: number,
  net: number,
  gross: number,
  vatPercentage: number,
  currency: string
}
